export const countryCodes = [
  {
    countryAlias: 'Afghanistan',
    countryName: 'Afghanistan',
    phoneCode: '+93',
  },
  {
    countryAlias: 'Albania',
    countryName: 'Albania',
    phoneCode: '+355',
  },
  {
    countryAlias: 'Algeria',
    countryName: 'Algeria',
    phoneCode: '+213',
  },
  {
    countryAlias: 'AmericanSamoa',
    countryName: 'American Samoa',
    phoneCode: '+1-684',
  },
  {
    countryAlias: 'Andorra',
    countryName: 'Andorra',
    phoneCode: '+376',
  },
  {
    countryAlias: 'Angola',
    countryName: 'Angola',
    phoneCode: '+244',
  },
  {
    countryAlias: 'Anguilla',
    countryName: 'Anguilla',
    phoneCode: '+1-264',
  },
  {
    countryAlias: 'Antarctica',
    countryName: 'Antarctica',
    phoneCode: '+672',
  },
  {
    countryAlias: 'AntiguaandBarbuda',
    countryName: 'Antigua and Barbuda',
    phoneCode: '+1-268',
  },
  {
    countryAlias: 'Argentina',
    countryName: 'Argentina',
    phoneCode: '+54',
  },
  {
    countryAlias: 'Armenia',
    countryName: 'Armenia',
    phoneCode: '+374',
  },
  {
    countryAlias: 'Aruba',
    countryName: 'Aruba',
    phoneCode: '+297',
  },
  {
    countryAlias: 'Australia',
    countryName: 'Australia',
    phoneCode: '+61',
  },
  {
    countryAlias: 'Austria',
    countryName: 'Austria',
    phoneCode: '+43',
  },
  {
    countryAlias: 'Azerbaijan',
    countryName: 'Azerbaijan',
    phoneCode: '+994',
  },
  {
    countryAlias: 'Bahamas',
    countryName: 'Bahamas',
    phoneCode: '+1-242',
  },
  {
    countryAlias: 'Bahrain',
    countryName: 'Bahrain',
    phoneCode: '+973',
  },
  {
    countryAlias: 'Bangladesh',
    countryName: 'Bangladesh',
    phoneCode: '+880',
  },
  {
    countryAlias: 'Barbados',
    countryName: 'Barbados',
    phoneCode: '+1-246',
  },
  {
    countryAlias: 'Belarus',
    countryName: 'Belarus',
    phoneCode: '+375',
  },
  {
    countryAlias: 'Belgium',
    countryName: 'Belgium',
    phoneCode: '+32',
  },
  {
    countryAlias: 'Belize',
    countryName: 'Belize',
    phoneCode: '+501',
  },
  {
    countryAlias: 'Benin',
    countryName: 'Benin',
    phoneCode: '+229',
  },
  {
    countryAlias: 'Bermuda',
    countryName: 'Bermuda',
    phoneCode: '+1-441',
  },
  {
    countryAlias: 'Bhutan',
    countryName: 'Bhutan',
    phoneCode: '+975',
  },
  {
    countryAlias: 'Bolivia',
    countryName: 'Bolivia',
    phoneCode: '+591',
  },
  {
    countryAlias: 'BosniaandHerzegovina',
    countryName: 'Bosnia and Herzegovina',
    phoneCode: '+387',
    flagAlias: 'bosniaherzegovina',
  },
  {
    countryAlias: 'Botswana',
    countryName: 'Botswana',
    phoneCode: '+267',
  },
  {
    countryAlias: 'Brazil',
    countryName: 'Brazil',
    phoneCode: '+55',
  },
  {
    countryAlias: 'BritishIndianOceanTerritory',
    countryName: 'British Indian Ocean Territory',
    phoneCode: '+246',
  },
  {
    countryAlias: 'VirginIslandsBritish',
    countryName: 'Virgin Islands (British)',
    phoneCode: '+1-284',
  },
  {
    countryAlias: 'BruneiDarussalam',
    countryName: 'Brunei Darussalam',
    phoneCode: '+673',
  },
  {
    countryAlias: 'Bulgaria',
    countryName: 'Bulgaria',
    phoneCode: '+359',
  },
  {
    countryAlias: 'BurkinaFaso',
    countryName: 'Burkina Faso',
    phoneCode: '+226',
  },
  {
    countryAlias: 'Burundi',
    countryName: 'Burundi',
    phoneCode: '+257',
  },
  {
    countryAlias: 'Cambodia',
    countryName: 'Cambodia',
    phoneCode: '+855',
  },
  {
    countryAlias: 'Cameroon',
    countryName: 'Cameroon',
    phoneCode: '+237',
  },
  {
    countryAlias: 'Canada',
    countryName: 'Canada',
    phoneCode: '+1',
  },
  {
    countryAlias: 'CapeVerde',
    countryName: 'Cape Verde',
    phoneCode: '+238',
  },
  {
    countryAlias: 'CaymanIslands',
    countryName: 'Cayman Islands',
    phoneCode: '+1-345',
  },
  {
    countryAlias: 'CentralAfricanRepublic',
    countryName: 'Central African Republic',
    phoneCode: '+236',
  },
  {
    countryAlias: 'Chad',
    countryName: 'Chad',
    phoneCode: '+235',
  },
  {
    countryAlias: 'Chile',
    countryName: 'Chile',
    phoneCode: '+56',
  },
  {
    countryAlias: 'China',
    countryName: 'China',
    phoneCode: '+86',
  },
  {
    countryAlias: 'ChristmasIsland',
    countryName: 'Christmas Island',
    phoneCode: '+61',
    flagAlias: 'christmas',
  },
  {
    countryAlias: 'CocosKeelingIslands',
    countryName: 'Cocos (Keeling) Islands',
    phoneCode: '+61',
    flagAlias: 'cocoskeeling',
  },
  {
    countryAlias: 'Colombia',
    countryName: 'Colombia',
    phoneCode: '+57',
  },
  {
    countryAlias: 'Comoros',
    countryName: 'Comoros',
    phoneCode: '+269',
  },
  {
    countryAlias: 'CookIslands',
    countryName: 'Cook Islands',
    phoneCode: '+682',
  },
  {
    countryAlias: 'CostaRica',
    countryName: 'Costa Rica',
    phoneCode: '+506',
  },
  {
    countryAlias: 'Croatia',
    countryName: 'Croatia',
    phoneCode: '+385',
  },
  {
    countryAlias: 'Cuba',
    countryName: 'Cuba',
    phoneCode: '+53',
  },
  {
    countryAlias: 'Curaçao',
    countryName: 'Curaçao',
    phoneCode: '+599',
    flagAlias: 'curacao',
  },
  {
    countryAlias: 'Cyprus',
    countryName: 'Cyprus',
    phoneCode: '+357',
  },
  {
    countryAlias: 'Czechia',
    countryName: 'Czechia',
    phoneCode: '+420',
    flagAlias: 'czechrepublic',
  },
  {
    countryAlias: 'DRCongo',
    countryName: 'DR Congo',
    phoneCode: '+243',
    flagAlias: 'congokinshasa',
  },
  {
    countryAlias: 'Denmark',
    countryName: 'Denmark',
    phoneCode: '+45',
  },
  {
    countryAlias: 'Djibouti',
    countryName: 'Djibouti',
    phoneCode: '+253',
  },
  {
    countryAlias: 'Dominica',
    countryName: 'Dominica',
    phoneCode: '+1-767',
  },
  {
    countryAlias: 'DominicanRepublic',
    countryName: 'Dominican Republic',
    phoneCode: '+1-809',
  },
  {
    countryAlias: 'DominicanRepublic',
    countryName: 'Dominican Republic',
    phoneCode: '+1-829',
  },
  {
    countryAlias: 'DominicanRepublic',
    countryName: 'Dominican Republic',
    phoneCode: '+1-849',
  },
  {
    countryAlias: 'Timor-Leste',
    countryName: 'Timor-Leste',
    phoneCode: '+670',
    flagAlias: 'timorleste',
  },
  {
    countryAlias: 'Ecuador',
    countryName: 'Ecuador',
    phoneCode: '+593',
  },
  {
    countryAlias: 'Egypt',
    countryName: 'Egypt',
    phoneCode: '+20',
  },
  {
    countryAlias: 'ElSalvador',
    countryName: 'El Salvador',
    phoneCode: '+503',
  },
  {
    countryAlias: 'EquatorialGuinea',
    countryName: 'Equatorial Guinea',
    phoneCode: '+240',
  },
  {
    countryAlias: 'Eritrea',
    countryName: 'Eritrea',
    phoneCode: '+291',
  },
  {
    countryAlias: 'Estonia',
    countryName: 'Estonia',
    phoneCode: '+372',
  },
  {
    countryAlias: 'Ethiopia',
    countryName: 'Ethiopia',
    phoneCode: '+251',
  },
  {
    countryAlias: 'FalklandIslandsMalvinas',
    countryName: 'Falkland Islands (Malvinas)',
    phoneCode: '+500',
    flagAlias: 'falkland',
  },
  {
    countryAlias: 'FaroeIslands',
    countryName: 'Faroe Islands',
    phoneCode: '+298',
  },
  {
    countryAlias: 'Fiji',
    countryName: 'Fiji',
    phoneCode: '+679',
  },
  {
    countryAlias: 'Finland',
    countryName: 'Finland',
    phoneCode: '+358',
  },
  {
    countryAlias: 'France',
    countryName: 'France',
    phoneCode: '+33',
  },
  {
    countryAlias: 'FrenchPolynesia',
    countryName: 'French Polynesia',
    phoneCode: '+689',
    flagAlias: 'tahiti',
  },
  {
    countryAlias: 'Gabon',
    countryName: 'Gabon',
    phoneCode: '+241',
  },
  {
    countryAlias: 'Gambia',
    countryName: 'Gambia',
    phoneCode: '+220',
  },
  {
    countryAlias: 'Georgia',
    countryName: 'Georgia',
    phoneCode: '+995',
  },
  {
    countryAlias: 'Germany',
    countryName: 'Germany',
    phoneCode: '+49',
  },
  {
    countryAlias: 'Ghana',
    countryName: 'Ghana',
    phoneCode: '+233',
  },
  {
    countryAlias: 'Gibraltar',
    countryName: 'Gibraltar',
    phoneCode: '+350',
  },
  {
    countryAlias: 'Greece',
    countryName: 'Greece',
    phoneCode: '+30',
  },
  {
    countryAlias: 'Greenland',
    countryName: 'Greenland',
    phoneCode: '+299',
  },
  {
    countryAlias: 'Grenada',
    countryName: 'Grenada',
    phoneCode: '+1-473',
  },
  {
    countryAlias: 'Guam',
    countryName: 'Guam',
    phoneCode: '+1-671',
  },
  {
    countryAlias: 'Guatemala',
    countryName: 'Guatemala',
    phoneCode: '+502',
  },
  {
    countryAlias: 'Guernsey',
    countryName: 'Guernsey',
    phoneCode: '+44-1481',
  },
  {
    countryAlias: 'Guinea',
    countryName: 'Guinea',
    phoneCode: '+224',
  },
  {
    countryAlias: 'Guinea-Bissau',
    countryName: 'Guinea-Bissau',
    phoneCode: '+245',
    flagAlias: 'guineabissau',
  },
  {
    countryAlias: 'Guyana',
    countryName: 'Guyana',
    phoneCode: '+592',
  },
  {
    countryAlias: 'Haiti',
    countryName: 'Haiti',
    phoneCode: '+509',
  },
  {
    countryAlias: 'Honduras',
    countryName: 'Honduras',
    phoneCode: '+504',
  },
  {
    countryAlias: 'HongKong',
    countryName: 'Hong Kong',
    phoneCode: '+852',
  },
  {
    countryAlias: 'Hungary',
    countryName: 'Hungary',
    phoneCode: '+36',
  },
  {
    countryAlias: 'Iceland',
    countryName: 'Iceland',
    phoneCode: '+354',
  },
  {
    countryAlias: 'India',
    countryName: 'India',
    phoneCode: '+91',
  },
  {
    countryAlias: 'Indonesia',
    countryName: 'Indonesia',
    phoneCode: '+62',
  },
  {
    countryAlias: 'Iran',
    countryName: 'Iran',
    phoneCode: '+98',
  },
  {
    countryAlias: 'Iraq',
    countryName: 'Iraq',
    phoneCode: '+964',
  },
  {
    countryAlias: 'Ireland',
    countryName: 'Ireland',
    phoneCode: '+353',
  },
  {
    countryAlias: 'IsleofMan',
    countryName: 'Isle of Man',
    phoneCode: '+44-1624',
  },
  {
    countryAlias: 'Israel',
    countryName: 'Israel',
    phoneCode: '+972',
  },
  {
    countryAlias: 'Italy',
    countryName: 'Italy',
    phoneCode: '+39',
  },
  {
    countryAlias: "Côted'Ivoire",
    countryName: "Côte d'Ivoire",
    phoneCode: '+225',
    flagAlias: 'cotedivoire',
  },
  {
    countryAlias: 'Jamaica',
    countryName: 'Jamaica',
    phoneCode: '+1-876',
  },
  {
    countryAlias: 'Japan',
    countryName: 'Japan',
    phoneCode: '+81',
  },
  {
    countryAlias: 'Jersey',
    countryName: 'Jersey',
    phoneCode: '+44-1534',
  },
  {
    countryAlias: 'Jordan',
    countryName: 'Jordan',
    phoneCode: '+962',
  },
  {
    countryAlias: 'Kazakhstan',
    countryName: 'Kazakhstan',
    phoneCode: '+7',
  },
  {
    countryAlias: 'Kenya',
    countryName: 'Kenya',
    phoneCode: '+254',
  },
  {
    countryAlias: 'Kiribati',
    countryName: 'Kiribati',
    phoneCode: '+686',
  },
  {
    countryAlias: 'Kosovo',
    countryName: 'Kosovo',
    phoneCode: '+383',
  },
  {
    countryAlias: 'Kuwait',
    countryName: 'Kuwait',
    phoneCode: '+965',
  },
  {
    countryAlias: 'Kyrgyzstan',
    countryName: 'Kyrgyzstan',
    phoneCode: '+996',
  },
  {
    countryAlias: "LaoPeople'sDemocraticRepublic",
    countryName: "Lao People's Democratic Republic",
    phoneCode: '+856',
    flagAlias: 'laos',
  },
  {
    countryAlias: 'Latvia',
    countryName: 'Latvia',
    phoneCode: '+371',
  },
  {
    countryAlias: 'Lebanon',
    countryName: 'Lebanon',
    phoneCode: '+961',
  },
  {
    countryAlias: 'Lesotho',
    countryName: 'Lesotho',
    phoneCode: '+266',
  },
  {
    countryAlias: 'Liberia',
    countryName: 'Liberia',
    phoneCode: '+231',
  },
  {
    countryAlias: 'Libya',
    countryName: 'Libya',
    phoneCode: '+218',
  },
  {
    countryAlias: 'Liechtenstein',
    countryName: 'Liechtenstein',
    phoneCode: '+423',
    flagAlias: 'liechtenshein',
  },
  {
    countryAlias: 'Lithuania',
    countryName: 'Lithuania',
    phoneCode: '+370',
  },
  {
    countryAlias: 'Luxembourg',
    countryName: 'Luxembourg',
    phoneCode: '+352',
  },
  {
    countryAlias: 'Macao',
    countryName: 'Macao',
    phoneCode: '+853',
    flagAlias: 'macau',
  },
  {
    countryAlias: 'NorthMacedonia',
    countryName: 'North Macedonia',
    phoneCode: '+389',
  },
  {
    countryAlias: 'Madagascar',
    countryName: 'Madagascar',
    phoneCode: '+261',
  },
  {
    countryAlias: 'Malawi',
    countryName: 'Malawi',
    phoneCode: '+265',
  },
  {
    countryAlias: 'Malaysia',
    countryName: 'Malaysia',
    phoneCode: '+60',
  },
  {
    countryAlias: 'Maldives',
    countryName: 'Maldives',
    phoneCode: '+960',
  },
  {
    countryAlias: 'Mali',
    countryName: 'Mali',
    phoneCode: '+223',
  },
  {
    countryAlias: 'Malta',
    countryName: 'Malta',
    phoneCode: '+356',
  },
  {
    countryAlias: 'MarshallIslands',
    countryName: 'Marshall Islands',
    phoneCode: '+692',
  },
  {
    countryAlias: 'Mauritania',
    countryName: 'Mauritania',
    phoneCode: '+222',
  },
  {
    countryAlias: 'Mauritius',
    countryName: 'Mauritius',
    phoneCode: '+230',
  },
  {
    countryAlias: 'Mayotte',
    countryName: 'Mayotte',
    phoneCode: '+262',
  },
  {
    countryAlias: 'Mexico',
    countryName: 'Mexico',
    phoneCode: '+52',
  },
  {
    countryAlias: 'MicronesiaFederatedStatesof',
    countryName: 'Micronesia (Federated States of)',
    phoneCode: '+691',
    flagAlias: 'micronesia',
  },
  {
    countryAlias: 'Moldova',
    countryName: 'Moldova',
    phoneCode: '+373',
  },
  {
    countryAlias: 'Monaco',
    countryName: 'Monaco',
    phoneCode: '+377',
  },
  {
    countryAlias: 'Mongolia',
    countryName: 'Mongolia',
    phoneCode: '+976',
  },
  {
    countryAlias: 'Montenegro',
    countryName: 'Montenegro',
    phoneCode: '+382',
  },
  {
    countryAlias: 'Montserrat',
    countryName: 'Montserrat',
    phoneCode: '+1-664',
  },
  {
    countryAlias: 'Morocco',
    countryName: 'Morocco',
    phoneCode: '+212',
  },
  {
    countryAlias: 'Mozambique',
    countryName: 'Mozambique',
    phoneCode: '+258',
  },
  {
    countryAlias: 'Myanmar',
    countryName: 'Myanmar',
    phoneCode: '+95',
  },
  {
    countryAlias: 'Namibia',
    countryName: 'Namibia',
    phoneCode: '+264',
  },
  {
    countryAlias: 'Nauru',
    countryName: 'Nauru',
    phoneCode: '+674',
  },
  {
    countryAlias: 'Nepal',
    countryName: 'Nepal',
    phoneCode: '+977',
  },
  {
    countryAlias: 'Netherlands',
    countryName: 'Netherlands',
    phoneCode: '+31',
  },
  {
    countryAlias: 'NetherlandsAntilles', // Note: This country code "AN" is deprecated in ISO 3166-1.
    countryName: 'Netherlands Antilles',
    phoneCode: '+599',
  },
  {
    countryAlias: 'NewCaledonia',
    countryName: 'New Caledonia',
    phoneCode: '+687',
  },
  {
    countryAlias: 'NewZealand',
    countryName: 'New Zealand',
    phoneCode: '+64',
  },
  {
    countryAlias: 'Nicaragua',
    countryName: 'Nicaragua',
    phoneCode: '+505',
  },
  {
    countryAlias: 'Niger',
    countryName: 'Niger',
    phoneCode: '+227',
  },
  {
    countryAlias: 'Nigeria',
    countryName: 'Nigeria',
    phoneCode: '+234',
  },
  {
    countryAlias: 'Niue',
    countryName: 'Niue',
    phoneCode: '+683',
  },
  {
    countryAlias: 'NorthKorea',
    countryName: 'North Korea',
    phoneCode: '+850',
  },
  {
    countryAlias: 'NorthernMarianaIslands',
    countryName: 'Northern Mariana Islands',
    phoneCode: '+1-670',
    flagAlias: 'northernmariana',
  },
  {
    countryAlias: 'Norway',
    countryName: 'Norway',
    phoneCode: '+47',
  },
  {
    countryAlias: 'Oman',
    countryName: 'Oman',
    phoneCode: '+968',
  },
  {
    countryAlias: 'Pakistan',
    countryName: 'Pakistan',
    phoneCode: '+92',
  },
  {
    countryAlias: 'Palau',
    countryName: 'Palau',
    phoneCode: '+680',
  },
  {
    countryAlias: 'PalestineStateof',
    countryName: 'Palestine, State of',
    phoneCode: '+970',
    flagAlias: 'palestine',
  },
  {
    countryAlias: 'Panama',
    countryName: 'Panama',
    phoneCode: '+507',
  },
  {
    countryAlias: 'PapuaNewGuinea',
    countryName: 'Papua New Guinea',
    phoneCode: '+675',
  },
  {
    countryAlias: 'Paraguay',
    countryName: 'Paraguay',
    phoneCode: '+595',
  },
  {
    countryAlias: 'Peru',
    countryName: 'Peru',
    phoneCode: '+51',
  },
  {
    countryAlias: 'Philippines',
    countryName: 'Philippines',
    phoneCode: '+63',
  },
  {
    countryAlias: 'Pitcairn',
    countryName: 'Pitcairn',
    phoneCode: '+64',
  },
  {
    countryAlias: 'Poland',
    countryName: 'Poland',
    phoneCode: '+48',
  },
  {
    countryAlias: 'Portugal',
    countryName: 'Portugal',
    phoneCode: '+351',
  },
  {
    countryAlias: 'PuertoRico',
    countryName: 'Puerto Rico',
    phoneCode: '+1-787',
  },
  {
    countryAlias: 'PuertoRico',
    countryName: 'Puerto Rico',
    phoneCode: '+1-939',
  },
  {
    countryAlias: 'Qatar',
    countryName: 'Qatar',
    phoneCode: '+974',
  },
  {
    countryAlias: 'CongoRepublic',
    countryName: 'Congo, Republic of the',
    phoneCode: '+242',
    flagAlias: 'congobrazzaville',
  },
  {
    countryAlias: 'Réunion',
    countryName: 'Réunion',
    phoneCode: '+262',
    flagAlias: 'reunion',
  },
  {
    countryAlias: 'Romania',
    countryName: 'Romania',
    phoneCode: '+40',
  },
  {
    countryAlias: 'RussianFederation',
    countryName: 'Russian Federation',
    phoneCode: '+7',
    flagAlias: 'russia',
  },
  {
    countryAlias: 'Rwanda',
    countryName: 'Rwanda',
    phoneCode: '+250',
  },
  {
    countryAlias: 'SaintBarthélemy',
    countryName: 'Saint Barthélemy',
    phoneCode: '+590',
    flagAlias: 'saintbarthelemy',
  },
  {
    countryAlias: 'SaintHelenaAscensionandTristanDaCunha',
    countryName: 'Saint Helena, Ascension and Tristan da Cunha',
    phoneCode: '+290',
    flagAlias: 'sainthelena',
  },
  {
    countryAlias: 'SaintKittsandNevis',
    countryName: 'Saint Kitts and Nevis',
    phoneCode: '+1-869',
  },
  {
    countryAlias: 'SaintLucia',
    countryName: 'Saint Lucia',
    phoneCode: '+1-758',
  },
  {
    countryAlias: 'SaintMartinFrenchpart',
    countryName: 'Saint Martin (French part)',
    phoneCode: '+590',
    flagAlias: 'saintmartin',
  },
  {
    countryAlias: 'SaintPierreandMiquelon',
    countryName: 'Saint Pierre and Miquelon',
    phoneCode: '+508',
  },
  {
    countryAlias: 'SaintVincentandtheGrenadines',
    countryName: 'Saint Vincent and the Grenadines',
    phoneCode: '+1-784',
    flagAlias: 'stvincentandthegrenadines',
  },
  {
    countryAlias: 'Samoa',
    countryName: 'Samoa',
    phoneCode: '+685',
  },
  {
    countryAlias: 'SanMarino',
    countryName: 'San Marino',
    phoneCode: '+378',
  },
  {
    countryAlias: 'SaoTomeandPrincipe',
    countryName: 'Sao Tome and Principe',
    phoneCode: '+239',
  },
  {
    countryAlias: 'SaudiArabia',
    countryName: 'Saudi Arabia',
    phoneCode: '+966',
  },
  {
    countryAlias: 'Senegal',
    countryName: 'Senegal',
    phoneCode: '+221',
  },
  {
    countryAlias: 'Serbia',
    countryName: 'Serbia',
    phoneCode: '+381',
  },
  {
    countryAlias: 'Seychelles',
    countryName: 'Seychelles',
    phoneCode: '+248',
  },
  {
    countryAlias: 'SierraLeone',
    countryName: 'Sierra Leone',
    phoneCode: '+232',
  },
  {
    countryAlias: 'Singapore',
    countryName: 'Singapore',
    phoneCode: '+65',
  },
  {
    countryAlias: 'SintMaartenDutchpart',
    countryName: 'Sint Maarten (Dutch part)',
    phoneCode: '+1-721',
    flagAlias: 'sintmaarten',
  },
  {
    countryAlias: 'Slovakia',
    countryName: 'Slovakia',
    phoneCode: '+421',
  },
  {
    countryAlias: 'Slovenia',
    countryName: 'Slovenia',
    phoneCode: '+386',
  },
  {
    countryAlias: 'SolomonIslands',
    countryName: 'Solomon Islands',
    phoneCode: '+677',
  },
  {
    countryAlias: 'Somalia',
    countryName: 'Somalia',
    phoneCode: '+252',
  },
  {
    countryAlias: 'SouthAfrica',
    countryName: 'South Africa',
    phoneCode: '+27',
  },
  {
    countryAlias: 'SouthKorea',
    countryName: 'South Korea',
    phoneCode: '+82',
  },
  {
    countryAlias: 'SouthSudan',
    countryName: 'South Sudan',
    phoneCode: '+211',
  },
  {
    countryAlias: 'Spain',
    countryName: 'Spain',
    phoneCode: '+34',
  },
  {
    countryAlias: 'SriLanka',
    countryName: 'Sri Lanka',
    phoneCode: '+94',
  },
  {
    countryAlias: 'Sudan',
    countryName: 'Sudan',
    phoneCode: '+249',
  },
  {
    countryAlias: 'Suriname',
    countryName: 'Suriname',
    phoneCode: '+597',
  },
  {
    countryAlias: 'SvalbardandJanMayen',
    countryName: 'Svalbard and Jan Mayen',
    phoneCode: '+47',
  },
  {
    countryAlias: 'Eswatini',
    countryName: 'Eswatini',
    phoneCode: '+268',
    flagAlias: 'swaziland',
  },
  {
    countryAlias: 'Sweden',
    countryName: 'Sweden',
    phoneCode: '+46',
  },
  {
    countryAlias: 'Switzerland',
    countryName: 'Switzerland',
    phoneCode: '+41',
  },
  {
    countryAlias: 'SyrianArabRepublic',
    countryName: 'Syrian Arab Republic',
    phoneCode: '+963',
    flagAlias: 'syria',
  },
  {
    countryAlias: 'TaiwanProvinceofChina',
    countryName: 'Taiwan, Province of China',
    phoneCode: '+886',
    flagAlias: 'chinesetaipei',
  },
  {
    countryAlias: 'Tajikistan',
    countryName: 'Tajikistan',
    phoneCode: '+992',
  },
  {
    countryAlias: 'TanzaniaUnitedRepublicof',
    countryName: 'Tanzania, United Republic of',
    phoneCode: '+255',
    flagAlias: 'unitedrepublicoftanzania',
  },
  {
    countryAlias: 'Thailand',
    countryName: 'Thailand',
    phoneCode: '+66',
  },
  {
    countryAlias: 'Togo',
    countryName: 'Togo',
    phoneCode: '+228',
  },
  {
    countryAlias: 'Tokelau',
    countryName: 'Tokelau',
    phoneCode: '+690',
  },
  {
    countryAlias: 'Tonga',
    countryName: 'Tonga',
    phoneCode: '+676',
  },
  {
    countryAlias: 'TrinidadandTobago',
    countryName: 'Trinidad and Tobago',
    phoneCode: '+1-868',
    flagAlias: 'trinidadtobago',
  },
  {
    countryAlias: 'Tunisia',
    countryName: 'Tunisia',
    phoneCode: '+216',
  },
  {
    countryAlias: 'Turkey',
    countryName: 'Turkey',
    phoneCode: '+90',
  },
  {
    countryAlias: 'Turkmenistan',
    countryName: 'Turkmenistan',
    phoneCode: '+993',
  },
  {
    countryAlias: 'TurksandCaicosIslands',
    countryName: 'Turks and Caicos Islands',
    phoneCode: '+1-649',
  },
  {
    countryAlias: 'Tuvalu',
    countryName: 'Tuvalu',
    phoneCode: '+688',
  },
  {
    countryAlias: 'VirginIslandsUS',
    countryName: 'Virgin Islands (U.S.)',
    phoneCode: '+1-340',
  },
  {
    countryAlias: 'Uganda',
    countryName: 'Uganda',
    phoneCode: '+256',
  },
  {
    countryAlias: 'Ukraine',
    countryName: 'Ukraine',
    phoneCode: '+380',
  },
  {
    countryAlias: 'UnitedArabEmirates',
    countryName: 'United Arab Emirates',
    phoneCode: '+971',
    flagAlias: 'uae',
  },
  {
    countryAlias: 'UnitedKingdom',
    countryName: 'United Kingdom',
    phoneCode: '+44',
  },
  {
    countryAlias: 'UnitedStates',
    countryName: 'United States',
    phoneCode: '+1',
    flagAlias: 'usa',
  },
  {
    countryAlias: 'Uruguay',
    countryName: 'Uruguay',
    phoneCode: '+598',
  },
  {
    countryAlias: 'Uzbekistan',
    countryName: 'Uzbekistan',
    phoneCode: '+998',
  },
  {
    countryAlias: 'Vanuatu',
    countryName: 'Vanuatu',
    phoneCode: '+678',
    flagAlias: 'vanutau',
  },
  {
    countryAlias: 'HolySee',
    countryName: 'Holy See (Vatican City)',
    phoneCode: '+379',
    flagAlias: 'vaticancity',
  },
  {
    countryAlias: 'VenezuelaBolivarianRepublicof',
    countryName: 'Venezuela, Bolivarian Republic of',
    phoneCode: '+58',
    flagAlias: 'venezuela',
  },
  {
    countryAlias: 'VietNam',
    countryName: 'Viet Nam',
    phoneCode: '+84',
  },
  {
    countryAlias: 'WallisandFutuna',
    countryName: 'Wallis and Futuna',
    phoneCode: '+681',
  },
  {
    countryAlias: 'WesternSahara',
    countryName: 'Western Sahara',
    phoneCode: '+212',
  },
  {
    countryAlias: 'Yemen',
    countryName: 'Yemen',
    phoneCode: '+967',
  },
  {
    countryAlias: 'Zambia',
    countryName: 'Zambia',
    phoneCode: '+260',
  },
  {
    countryAlias: 'Zimbabwe',
    countryName: 'Zimbabwe',
    phoneCode: '+263',
  },
];
